var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHouse(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "300.000000pt",
    height: "300.000000pt",
    viewBox: "0 0 300.000000 300.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,300.000000) scale(0.100000,-0.100000)",
    fill: "#ffffff",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1069 2542 c-235 -207 -571 -505 -747 -661 l-321 -285 39 -45 c22 -25 57 -66 78 -90 l39 -44 662 587 c364 323 668 589 675 592 8 3 293 -243 682 -587 l667 -592 39 44 c21 24 56 65 78 90 l39 45 -744 660 c-410 362 -748 660 -752 661 -5 2 -200 -167 -434 -375z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450 2448 l0 -282 38 35 c20 20 103 95 184 167 l146 132 4 108 c2 59 2 110 0 115 -2 4 -86 7 -188 7 l-184 0 0 -282z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M968 1938 l-518 -460 0 -683 c0 -648 1 -683 18 -698 17 -15 56 -17 360 -17 l342 0 0 303 c0 246 3 307 14 323 14 18 29 19 316 19 287 0 302 -1 316 -19 11 -16 14 -77 14 -323 l0 -303 338 0 c289 0 341 2 360 16 l22 15 0 684 0 683 -520 461 c-286 254 -525 461 -532 460 -7 0 -246 -208 -530 -461z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHouse);
export default __webpack_public_path__ + "static/media/house.c85840b1d48660312dd4d6d461c64683.svg";
export { ForwardRef as ReactComponent };